import { SET_ONLINE } from 'components/online/constants'

export default function SetOnline(online) {
  return {
    type: SET_ONLINE,
    online,
  }
}
